import { render, staticRenderFns } from "./UploadDoc.vue?vue&type=template&id=1d6abd77&"
import script from "./UploadDoc.vue?vue&type=script&lang=js&"
export * from "./UploadDoc.vue?vue&type=script&lang=js&"
import style0 from "./UploadDoc.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VFileInput,VRadio,VRadioGroup})
